/** The one Insights card that holds every store-knowledge state: question, picker, loading, error and saved answers. */
import type { ReactNode } from 'react'
import { storeKnowledgeCopy as copy } from '@testfeed/product-language'
export function StoreKnowledgeCard({ children }: { children: ReactNode }) {
  return (
    <s-section heading={copy.heading}>
      <s-icon slot="graphic" type="question-circle" />
      <s-stack gap="base">
        <s-paragraph color="subdued">{copy.intro}</s-paragraph>
        {children}
      </s-stack>
    </s-section>
  )
}
